/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Button, CardMedia, Grid, IconButton, Theme, Typography } from '@mui/material';
import { ProceedSaveLater, SubHeading } from './components';
import { Formik, useFormikContext, validateYupSchema, yupToFormErrors } from 'formik';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import React, { useEffect, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import MFCheckbox from '../../lib/formik/Checkbox';
import { mdmsCountriesList, nationaliyType } from '../../redux-store/types/mdms';
import { getNationalityList } from '../../redux-store/actions';
import { ApplicationProps, NomineeType } from '../../redux-store/types/api-types';
import {
  applicationComparison,
  applyRoleBasedStatus,
  getApplicantName,
  getNomineeName,
  getNomineeRelation,
  getUniqueIdentityText,
  isMinor,
  isOnboardingTypeMinor,
  preventSpecialCharacters,
  removeSingleQuote,
  saveForLater,
} from '../../utils/utilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { useHistory, useRouteMatch } from 'react-router';
import { updateApplication } from '../../redux-store/actions/application';
// import { DatePicker } from '../../lib/formik/DatePicker';
import { ConfirmationDialog, CountryCodesDropDown } from '../commonComponents';
import { nomineeDetailsSchema } from '../../utils/schema';
import MFSelectField from '../../lib/formik/SelectField';
import { AMC_APPROVER_CHECK_FOR_INDIVIDUAL, idProofLabelsMasters, IdProofsMasters, NomineeRelations } from '../../utils/constant';
import { Notes } from './components';
import { useSnackbar } from 'notistack';
import { TextDatePicker } from '../onboarding/DatePickerWithTextFeild';
import { DeleteIconFilled } from '../../assets/SvgIcons';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { initiateNomineeModification, initiateNomineeModificationBody, initiateNomineeModificationRes } from '../../redux-store/actions/nominee';
import { showError } from '../../redux-store/actions/auth';

export type updateNominee = NomineeType & {
  Relationship: string | null;
  sno?: number;
};

type Values = {
  doNotWishToNominate: boolean;
  nominees: updateNominee[];
  nomineesSOA: boolean;
  saveType: string;
};

const newNominee: updateNominee = {
  nomineeName: '',
  nomineeRelationship: '',
  dateOfBirth: null,
  nomineePercentage: 0,
  guardianName: '',
  // nomineePan: '',
  nomineeGuardianPan: '',
  isActive: true,
  Relationship: '',
  sno: 0,
  //added according to new requirements
  idProofType: '',
  idProofValue: '',
  mobile: '',
  email: '',
  address1: '',
  address2: '',
  address3: '',
  pincode: '',
  city: '',
  state: '',
  country: '',
  countryNameAndCode: 'India: +91',
  countryCode: '+91',
  addressSameAsApplicant: false,
};

const initialValues: Values = {
  doNotWishToNominate: true,
  nominees: [newNominee],
  nomineesSOA: false,
  saveType: 'save and proceed',
};

const Nominee = ({
  nomineeName,
  index,
  values,
  mdmsCountriesList,
  nomineeTitle,
  application
}: {
  nomineeName: number;
  index: number;
  values: Values;
  mdmsCountriesList: mdmsCountriesList[];
  nomineeTitle: string;
  application: ApplicationProps | null
}): JSX.Element => {
  const nomineeValues = values.nominees[index];
  const { dateOfBirth = '', nomineeGuardianPan = '', addressSameAsApplicant = '', address1, address2, address3, city, state, pincode, country } = nomineeValues;
  const anyAddressFilled = !!(address1 || address2 || address3 || city || state || pincode || country);
  const { setFieldValue, setValues } = useFormikContext();
  const { company = "WMS" } = useSelector((state: RootStateType) => state.navbarInfo)
  const nomineeAddress = application?.nominees
  const permanentAddress = application?.applicants?.[0]?.addresses?.find((address) => (address.address_type ?? "").toLowerCase() === 'permanent');

  const [mobileElementWidth, setMobileElementWidth] = useState(null);
  useEffect(() => {
    const mobileElement = document.getElementsByName('nominees.0.countryNameAndCode');
    setMobileElementWidth(mobileElement[0]?.parentElement?.clientWidth as any);
  }, []);
  console.log('address-index', addressSameAsApplicant)

  const handleNomineeAddressSameAsApplicant = (checked: boolean) => {
    if (checked) {
      setValues({
        ...values,
        nominees: values.nominees.map((nominee, ind) => {
          if (ind === index) {
            return {
              ...nominee,
              address1: permanentAddress?.address1 ?? '',
              address2: permanentAddress?.address2 ?? '',
              address3: permanentAddress?.address3 ?? '',
              pincode: permanentAddress?.pincode ?? '',
              city: permanentAddress?.city ?? '',
              state: permanentAddress?.state ?? '',
              country: permanentAddress?.country ?? '',
              addressSameAsApplicant: checked
            }
          }
          return nominee;
        })
      })
    }
    else {
      setValues({
        ...values,
        nominees: values.nominees.map((nominee, ind) => {
          if (ind === index) {
            return {
              ...nominee,
              address1: nomineeAddress?.[ind]?.address1 ?? '',
              address2: nomineeAddress?.[ind]?.address2 ?? '',
              address3: nomineeAddress?.[ind]?.address3 ?? '',
              pincode: nomineeAddress?.[ind]?.pincode ?? '',
              city: nomineeAddress?.[ind]?.city ?? '',
              state: nomineeAddress?.[ind]?.state ?? '',
              country: nomineeAddress?.[ind]?.country ?? '',
              addressSameAsApplicant: checked
            }
          }
          return nominee;
        })
      })
    }
  }

  return (
    <>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.nomineeName`}
          label={`Enter Nominee Name ${nomineeName}*`}
          placeholder={`Enter Nominee Name ${nomineeName}`}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFSelectField
          name={`nominees.${index}.Relationship`}
          label="Select Nominee Relationship*"
          items={NomineeRelations.filter((relation) => {
            const { nominees } = values;
            const selectedRelations = nominees
              .filter(
                (nominee, ind) =>
                  ind !== index &&
                  nominee.Relationship &&
                  nominee.isActive &&
                  ['MOTHER', 'FATHER', 'SPOUSE'].includes(nominee.Relationship)
              )
              .map((nominee) => nominee.Relationship);
            return !selectedRelations.includes(relation);
          }).map((relation) => ({
            key: relation,
            value: relation,
          }))}
          isCapitalize
        />
      </Grid>
      {values.nominees.map((nominee, idx: number) => {
        if (nominee.Relationship === 'OTHERS' && idx === index) {
          return (
            <Grid item xs={12} lg={6} key={idx}>
              <MFTextField
                name={`nominees.${index}.nomineeRelationship`}
                label="Please Specify Relationship*"
                placeholder={`Enter Nominee Relationship`}
              />
            </Grid>
          );
        }
      })}
      <Grid item xs={12} lg={6}>
        <TextDatePicker
          label={'Date of Birth *'}
          inputLabelStyles={{
            transform: 'unset',
            fontSize: 14,
            fontWeight: 500,
            color: 'rgba(0,0,0,0.7)',
          }}
          placeholder={'Enter Date of Birth'}
          name={`nominees.${index}.dateOfBirth`}
          minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 125))}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.nomineePercentage`}
          label="Nominee % *"
          placeholder="Enter Nominee %"
          onKeyDown={(e) => {
            if (['-', '+', '.'].includes(e.key)) {
              e.preventDefault();
            }
          }}
        />
      </Grid>
      {/* <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.nomineePan`}
          label={`Enter Nominee ${getUniqueIdentityText(company)?.pan}`}
          placeholder={`Enter Nominee ${getUniqueIdentityText(company)?.pan}`}
          inputProps={{ style: { textTransform: 'uppercase' } }}
          onChange={(e) => {
            setFieldValue(`nominees.${index}.nomineePan`, e.target.value.toUpperCase());
          }}
        />
      </Grid> */}
      {isMinor(dateOfBirth ? dateOfBirth : '') && (
        <>
          <Grid item xs={12} lg={6}>
            <MFTextField
              name={`nominees.${index}.guardianName`}
              label={nomineeGuardianPan ? "Enter Guardian Name*" : "Enter Guardian Name"}
              placeholder="Enter Guardian Name"
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <MFTextField
              name={`nominees.${index}.nomineeGuardianPan`}
              label={`Enter Guardian ${getUniqueIdentityText(company)?.pan}`}
              placeholder="Enter Guardian Pan"
              inputProps={{ style: { textTransform: 'uppercase' } }}
              onChange={(e) => {
                setFieldValue(`nominees.${index}.nomineeGuardianPan`, e.target.value.toUpperCase());
              }}
            />
          </Grid>
        </>
      )}
      <Grid item xs={12}>
        <SubHeading
          sx={{
            letterSpacing: '0.02px',
          }}>
          Address & Contact Details of {nomineeTitle} Nominee
        </SubHeading>
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFSelectField
          name={`nominees.${index}.idProofType`}
          label={`Any one of the id proof`}
          items={IdProofsMasters.map(proof => ({ key: proof, value: proof }))}
          onChange={
            (e) => {
              setFieldValue(`nominees.${index}.idProofType`, e.target.value);
              setFieldValue(`nominees.${index}.idProofValue`, '');
            }
          }
          {...(values.nominees[index].idProofType
            ? {
              // Show a clear (×) button inside the select when a value is selected;
              // shift it left so it doesn't overlap the dropdown arrow.
              endAdornment: (
                <IconButton
                  size="small"
                  aria-label="Clear ID proof type"
                  onClick={() => {
                    setFieldValue(`nominees.${index}.idProofType`, '');
                    setFieldValue(`nominees.${index}.idProofValue`, '');
                  }}
                  sx={{ mr: 2 }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              ),
            }
             : {})}

        />
      </Grid>
      {/* [CORR-02] ID proof optional by design; value field + `*` render only once a
          type is picked, matching idProofValue's when(isActive && !!idProofType). */}
      {values.nominees[index].idProofType && (
        <Grid item xs={12} lg={6}>
          <MFTextField
            name={`nominees.${index}.idProofValue`}
            label={`${idProofLabelsMasters[values.nominees[index].idProofType as string]}*`}
            placeholder={idProofLabelsMasters[values.nominees[index].idProofType as string]}
            inputProps={{ style: { textTransform: 'uppercase' } }}
            onChange={(e) => {
              setFieldValue(`nominees.${index}.idProofValue`, e.target.value.toUpperCase());
            }}
          />
        </Grid>
      )}
      <Grid item xs={12} lg={6}>
        {/* <MFTextField
          name={`nominees.${index}.mobile`}
          label={`Mobile*`}
          placeholder="Mobile"
        /> */}
        {/* [CORR-01] Mobile optional (no `*`): nomineeDetailsSchema only format-validates
            mobile, never requires it, so label and schema agree. */}
        <MFTextField
          name={`nominees.${index}.mobile`}
          label={`Mobile`}
          placeholder="Mobile"
          onKeyDown={(e) => {
            preventSpecialCharacters(e);
          }}
          startAdornment={
            <CountryCodesDropDown
              ElementWidth={mobileElementWidth && mobileElementWidth}
              name={`nominees.${index}.countryNameAndCode`}
              value={values.nominees[index].countryNameAndCode ?? ""}
            />
          }
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.email`}
          label={`Email`}
          placeholder="Email"
        />
      </Grid>
      <Grid item xs={12} sx={{ alignSelf: 'center' }}>
        <MFCheckbox
          checked={addressSameAsApplicant === 'Y'}
          onChange={({ target: { checked } }) => {
            handleNomineeAddressSameAsApplicant(checked)
          }}
          name={`nominees.${index}.addressSameAsApplicant`}
          label={`Nominee address same as applicant address`}
        />
      </Grid>
      {/* [CORR-01] Address all-or-nothing: `*` shown via `anyAddressFilled`; matches the
          `*-required-when-any-address` tests in nomineeDetailsSchema. */}
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.address1`}
          label={`Address Line 1${anyAddressFilled ? '*' : ''}`}
          placeholder="Address Line 1"
          onChange={({ target: { value } }) => {
            setFieldValue(`nominees.${index}.addressSameAsApplicant`, false);
            setFieldValue(`nominees.${index}.address1`, value ?? '');
          }}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.address2`}
          label={`Address Line 2`}
          placeholder="Address Line 2"
          onChange={({ target: { value } }) => (setFieldValue(`nominees.${index}.addressSameAsApplicant`, false), setFieldValue(`nominees.${index}.address2`, value ?? ''))}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.address3`}
          label={`Address Line 3`}
          placeholder="Address Line 3"
          onChange={({ target: { value } }) => (setFieldValue(`nominees.${index}.addressSameAsApplicant`, false), setFieldValue(`nominees.${index}.address3`, value ?? ''))}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.pincode`}
          label={`PIN Code${anyAddressFilled ? '*' : ''}`}
          placeholder="PIN Code"
          onChange={({ target: { value } }) => (setFieldValue(`nominees.${index}.addressSameAsApplicant`, false), setFieldValue(`nominees.${index}.pincode`, value ?? ''))}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.city`}
          label={`City${anyAddressFilled ? '*' : ''}`}
          placeholder="City"
          onChange={({ target: { value } }) => (setFieldValue(`nominees.${index}.addressSameAsApplicant`, false), setFieldValue(`nominees.${index}.city`, value ?? ''))}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.state`}
          label={`State${anyAddressFilled ? '*' : ''}`}
          placeholder="State"
          onChange={({ target: { value } }) => (setFieldValue(`nominees.${index}.addressSameAsApplicant`, false), setFieldValue(`nominees.${index}.state`, value ?? ''))}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <SearchableSelect
          name={`nominees.${index}.country`}
          label={`Country${anyAddressFilled ? '*' : ''}`}
          items={mdmsCountriesList.map((nationality) => ({
            key: nationality.name,
            value: nationality.name,
          }))}
          searchFieldPlaceholder={'Search Country'}
          onChange={({ target: { value } }) => (setFieldValue(`nominees.${index}.addressSameAsApplicant`, false), setFieldValue(`nominees.${index}.country`, value ?? ''))}
        />

      </Grid>
    </>
  );
};

export default function NomineeDetails({ isDirect = false, applicationId = '' }: { isDirect?: boolean; applicationId?: string; }): JSX.Element {
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { company = "WMS" } = useSelector((store: RootStateType) => store.navbarInfo)
  const { currencyCode = "INR" } = useSelector((store: RootStateType) => store.currencyInfo);
  const [nomineesData, setNomineesData] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const [nomineeToDelete, setNomineeToDelete] = useState<{
    nominee: Partial<NomineeType>;
    index: number;
  } | null>(null);
  // const [nomineesToDelete, setNomineesToDelete] = useState<
  //   | {
  //       nominee: Partial<NomineeType>;
  //       // index: number;
  //     }[]
  //   | null
  // >(null);
  const [bulkNomineeDelete, setBulkNomineeDelete] = useState<boolean>(false);
  const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const { path: currentPath } = useRouteMatch();

  const isDiyInvestorOnboarding = currentPath?.includes("/investor-onboarding-application")

  useEffect(() => {
    (async function () {
      try {
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;
        setMdmsCountriesList(nationalitiesMdmsMasters.countries);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);

  const onSubmit = async (values: Values) => {
    try {
      if (isDirect) {
        const {
          nominees: existingNominees = [],
          id: applicationId,
          clientCode
        } = application || {};
        const { nominees, doNotWishToNominate } = values;
        const updatedPayload = {
          doNotWishToNominate,
          nominees: nominees
            .filter((nominee) => nominee?.id || nominee.isActive)
            .map((nominee, index) => {
              const { id = null } = existingNominees[index] || {};
              if (nominee.id === id) {
                const { Relationship, sno, ...rest } = nominee;
                return {
                  ...(existingNominees[index] || {}),
                  ...rest,
                  applicationId,
                  countryCode: rest.countryNameAndCode?.split(':')[1].trim(),
                  nomineeRelationship: getNomineeRelation(Relationship)
                    ? Relationship
                    : removeSingleQuote(nominee.nomineeRelationship),
                  dateOfBirth: !nominee.dateOfBirth
                    ? null
                    : new Date(nominee.dateOfBirth).toISOString(),
                  isActive: nominee.isActive && !doNotWishToNominate,
                  nomineeName: removeSingleQuote(rest.nomineeName),
                  guardianName: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                    ? removeSingleQuote(rest.guardianName)
                    : null,
                  nomineeGuardianPan: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                    ? removeSingleQuote(rest.nomineeGuardianPan)
                    : null,
                  addressSameAsApplicant: rest.addressSameAsApplicant ? 'Y' : 'N',
                };
              };
              const { Relationship, sno, ...rest1 } = nominees[nominee.sno as number];
              return {
                ...rest1,
                nomineeRelationship: getNomineeRelation(Relationship)
                  ? Relationship
                  : removeSingleQuote(nominee.nomineeRelationship),
                nomineeName: removeSingleQuote(rest1.nomineeName),
                guardianName: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                  ? removeSingleQuote(rest1.guardianName)
                  : null,
                nomineeGuardianPan: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                  ? removeSingleQuote(rest1.nomineeGuardianPan)
                  : null,
                addressSameAsApplicant: rest1.addressSameAsApplicant ? 'Y' : 'N',
                applicationId,
              };
            }),
          nomineesSOA: values?.doNotWishToNominate ? false : values?.nomineesSOA ?? false,
          clientCode: clientCode ?? '',
        };

        try {
          setLoading(true);
          const res = await (dispatch(initiateNomineeModification(updatedPayload))) as unknown as initiateNomineeModificationRes;
          if (!res) {
            return
          };
          if (res?.isSuccess) {
            history.push(`/nominee/otp-screen`, {
              id: res?.id ?? "",
              cartId: res?.cartId ?? "",
              message: res?.message ?? "",
              token: res?.token ?? "",
            });
          }
        } catch (e) {
          dispatch(showError("Please Try Again"))
        } finally {
          setLoading(false);

        }

      } else {
        const {
          nominees: existingNominees = [],
          id,
          applicant1ReferenceId = '',
          currentStep,
          status,
          hasPOA,
          applicationNumber,
        } = application || {};
        const { nominees, doNotWishToNominate, saveType } = values;
        const updatedPayload = {
          ...application,
          doNotWishToNominate,
          nominees: nominees
            .filter((nominee) => nominee?.id || nominee.isActive)
            .map((nominee, index) => {
              const { id = null } = existingNominees[index] || {};
              if (nominee.id === id) {
                const { Relationship, sno, ...rest } = nominee;
                return {
                  ...(existingNominees[index] || {}),
                  ...rest,
                  countryCode: rest.countryNameAndCode?.split(':')[1].trim(),
                  nomineeRelationship: getNomineeRelation(Relationship)
                    ? Relationship
                    : removeSingleQuote(nominee.nomineeRelationship),
                  dateOfBirth: !nominee.dateOfBirth
                    ? null
                    : new Date(nominee.dateOfBirth).toISOString(),
                  isActive: nominee.isActive && !doNotWishToNominate,
                  nomineeName: removeSingleQuote(rest.nomineeName),
                  guardianName: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                    ? removeSingleQuote(rest.guardianName)
                    : null,
                  nomineeGuardianPan: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                    ? removeSingleQuote(rest.nomineeGuardianPan)
                    : null,
                  addressSameAsApplicant: rest.addressSameAsApplicant ? 'Y' : 'N',
                };
              }
              const { Relationship, sno, ...rest1 } = nominees[nominee.sno as number];
              return {
                ...rest1,
                countryCode: rest1.countryNameAndCode?.split(':')[1].trim(),
                nomineeRelationship: removeSingleQuote(rest1.nomineeRelationship),
                nomineeName: removeSingleQuote(rest1.nomineeName),
                guardianName: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                  ? removeSingleQuote(rest1.guardianName)
                  : null,
                nomineeGuardianPan: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                  ? removeSingleQuote(rest1.nomineeGuardianPan)
                  : null,
                addressSameAsApplicant: rest1.addressSameAsApplicant ? 'Y' : 'N',
              };
            }),
          nomineesSOA: values?.doNotWishToNominate ? false : values?.nomineesSOA ?? false,
        };
        const checkApplication = applicationComparison(
          {
            ...application,
            nominees: application?.nominees?.sort(
              (nominee1, nominee2) => Number(nominee1.id) - Number(nominee2.id)
            ),
          },
          {
            ...updatedPayload,
            nominees: updatedPayload.nominees?.sort(
              (nominee1, nominee2) => Number(nominee1.id) - Number(nominee2.id)
            ),
            // currentStep: !!currentStep && currentStep > 5 ? currentStep : Number(currentStep) + 1,
            currentStep: !!currentStep && currentStep > 4 ? currentStep : Number(currentStep) + 1,
          }
        );
        const isSaveLater = saveType !== 'save and proceed';
        if (id && !checkApplication) {
          setLoading(true);
          const response = await dispatch(
            updateApplication({
              body: {
                ...updatedPayload,
                status:
                  !hasPOA &&
                    AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                    status !== 'draft' &&
                    applyRoleBasedStatus(role)
                    ? 'sent_to_amc_approver'
                    : status,
                currentStep: 5,
                //!!currentStep && currentStep > 5 ? currentStep : Number(currentStep) + 1,
              },
              applicationId: id,
              ...(isSaveLater && { toastMessage: '' }),
            })
          );
          if (!response) return;
          !isSaveLater
            ? history.push('fatca', { id, applicant1ReferenceId })
            : history.push(saveForLater(role, id, applicant1ReferenceId, isDiyInvestorOnboarding));
        } else if (checkApplication) {
          if (isSaveLater) {
            enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
              variant: 'success',
              autoHideDuration: 3000,
            });
          }
          !isSaveLater
            ? history.push('fatca', { id, applicant1ReferenceId })
            : history.push(saveForLater(role, id, applicant1ReferenceId, isDiyInvestorOnboarding));
        }
      }
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const { nominees = [], doNotWishToNominate = true, onboardingType = '', nomineesSOA } = application || {};
    console.log('nominee-useeffect', nominees);
    setNomineesData({
      ...nomineesData,
      doNotWishToNominate: nominees.length
        ? false
        : doNotWishToNominate === null
          ? true
          : doNotWishToNominate,
      nominees: nominees.length
        ? nominees.map((nominee, index) => {
          return ({
            ...nominee,
            Relationship: getNomineeRelation(nominee.nomineeRelationship?.toUpperCase())
              ? nominee.nomineeRelationship
                ? nominee.nomineeRelationship.toUpperCase()
                : nominee.nomineeRelationship
              : 'OTHERS',
            nomineeRelationship: getNomineeRelation(nominee.nomineeRelationship?.toUpperCase())
              ? ''
              : nominee.nomineeRelationship,
            sno: index,
            nomineePercentage: nominee.nomineePercentage
              ? nominee.nomineePercentage
              : nominees.length === 1
                ? 100
                : 0,
            countryNameAndCode: nominee.countryNameAndCode ?? 'India: +91',
            addressSameAsApplicant: nominee.addressSameAsApplicant ? (`${nominee.addressSameAsApplicant ?? 'N'}`.toUpperCase() == 'Y' ? true : false) : false,
          })
        })
        : [],
      nomineesSOA: doNotWishToNominate ? false : nomineesSOA ?? false
    });
  }, [application]);

  const { onboardingType = '' } = application || {};

  return (
    <Formik
      initialValues={nomineesData}
      onSubmit={onSubmit}
      enableReinitialize={true}
      validate={(values: Values) => {
        try {
          validateYupSchema(values, nomineeDetailsSchema(application?.applicants, currencyCode, company), true, values);
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}>
      {({ handleSubmit, values, setValues, dirty }) => {
        console.log('values-form', values);
        const nomineePercentage = values
          ?.nominees
          ?.filter((_nominee) => _nominee.isActive)
          ?.reduce((acc, curr) => acc = acc + Number(curr.nomineePercentage), 0)

        return (
          <Grid
            container
            // rowSpacing={1}
            // columnSpacing={5}
            columnSpacing={3}
            rowSpacing={0.5}
            // sx={{
            //   width: '100%',
            //   ml: 0,
            //   '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
            // }}
            component="form"
            noValidate
            onSubmit={handleSubmit}
          onKeyDown={(e: React.KeyboardEvent) => {
            if (e.key === 'Enter' && (e.target as HTMLElement).tagName !== 'BUTTON' && (e.target as HTMLElement).getAttribute('type') !== 'submit') {
              e.preventDefault();
            }
          }}>
            <Grid item xs={12}>
              {/* <Notes displayContent={`Investor(s) have the option to choose upto ten nominees.${isOnboardingTypeMinor(onboardingType) ? ' Note:- Guardian will be the nominee' : ''}`} /> */}
              <Notes displayContent={`Investor(s) have the option to choose upto three nominees.`} />
            </Grid>
            <Grid item xs={12} my={2}>
              <Box sx={(theme: Theme) => ({
                width: "fit-content",
                [theme.breakpoints.down('sm')]: {
                  mt: "-14px"
                }
              })}>
                <MFCheckbox
                  // disabled={isOnboardingTypeMinor(onboardingType)}
                  name="doNotWishToNominate"
                  label="I do not wish to nominate."
                  sx={{ letterSpacing: '1px' }}
                  onChange={({ target: { checked } }) => {
                    const updatedNominees = !checked
                      ? [
                        ...values.nominees,
                        { ...newNominee, nomineePercentage: 100, sno: values.nominees.length },
                      ]
                      : values.nominees;
                    setValues({
                      ...nomineesData,
                      doNotWishToNominate:
                        values.nominees?.filter((item) => item.isActive).length === 0
                          ? checked
                          : !checked,
                      nominees: updatedNominees.map((nominee) => ({
                        ...nominee,
                      })),
                      nomineesSOA: values.nomineesSOA
                    });
                    checked && setBulkNomineeDelete(true);
                  }}
                  checked={values.doNotWishToNominate}
                />
              </Box>
            </Grid>
            {values.nominees
              .filter((_nominee) => _nominee.isActive)
              .map((nominee, index) => {
                const nomineeTitle = getNomineeName(index + 1, true)
                return (<React.Fragment key={index}>
                  <Grid item xs={12}>
                    <SubHeading
                      sx={(theme: Theme) => ({
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        [theme.breakpoints.down('sm')]: {
                          marginTop: '-14px', padding: "10px"
                        },
                      })}>
                      <Typography variant='body_500' color="primary.200">
                        {nomineeTitle} Nominee Details
                      </Typography>
                      {/* <Box
                        sx={{ display: 'flex', alignItems: 'center' }}
                        onClick={() => setNomineeToDelete({ nominee, index: nominee.sno as number })}>
                        <Typography
                          sx={{
                            color: 'rgba(196, 42, 51, 0.8)',
                            fontSize: 12,
                            ml: 'auto',
                            letterSpacing: '-0.2px',
                            cursor: 'pointer',
                          }}>
                          Remove Nominee{' '}
                        </Typography>
                        <IconButton sx={{ p: '2px' }}>
                          <CardMedia
                            component="img"
                            src="/images/delete-red.svg"
                            alt="Delete Icon"
                            sx={{ width: 'unset' }}
                          />
                        </IconButton>
                      </Box> */}
                      <Box
                        role="button"
                        tabIndex={0}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "primary.100",
                          borderRadius: "50%",
                          padding: "5px",
                          cursor: "pointer",
                        }}
                        onClick={() => setNomineeToDelete({ nominee, index: nominee.sno as number })}
                        onKeyDown={(e: React.KeyboardEvent) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            setNomineeToDelete({ nominee, index: nominee.sno as number });
                          }
                        }}
                        aria-label={`Delete nominee ${index + 1}`}
                      >
                        <DeleteIconFilled />
                      </Box>
                    </SubHeading>
                  </Grid>
                  <Nominee
                    nomineeName={index + 1}
                    index={nominee.sno as number}
                    key={nominee.sno as number}
                    mdmsCountriesList={mdmsCountriesList}
                    nomineeTitle={nomineeTitle}
                    values={values}
                    application={application}
                  />
                  <Grid item xs={12} my={1} />
                </React.Fragment>)
              })}
            {values.nominees.filter((item) => item.isActive).length < 3 && (
              <Grid item xs={12}>
                <Button
                  // variant="contained"
                  variant='outlined'
                  startIcon={<AddIcon sx={{
                    color: ((nomineePercentage >= 100)) ? 'grey.500' : 'primary.500'
                  }} />}
                  sx={(theme: Theme) => ({
                    // color: 'common.white',
                    // fontWeight: 500,
                    // fontSize: 14,
                    [theme.breakpoints.down('sm')]: {
                      mt: "-14px"
                    },
                    // mx: 1,
                    backgroundColor: `${theme.palette.primary[500]}1A`,
                    border: `1px solid ${theme.palette.primary[500]}`,
                    ...theme.typography.body_500,
                    color: theme.palette.primary[500],
                    padding: "10px 15px",
                    '&.Mui-disabled': {
                      backgroundColor: theme.palette.textDark.disabled
                    }
                  })}
                  disabled={(nomineePercentage >= 100)}
                  onClick={() =>
                    setValues({
                      ...values,
                      nominees: [
                        ...values.nominees,
                        {
                          ...newNominee,
                          nomineePercentage: values.nominees.filter((item) => item.isActive).length
                            ? 0
                            : 100,
                          sno: values.nominees.length,
                        },
                      ],
                      doNotWishToNominate: false,
                    })
                  }>
                  Add Nominee
                </Button>
              </Grid>
            )}
            {!values.doNotWishToNominate && <Grid item xs={12} mt={2}>
              <MFCheckbox
                name="nomineesSOA"
                label="Display Nominees in SOA"
                checked={values.nomineesSOA}
              />
            </Grid>}
            <Grid item xs={12} my={2} />
            {
              isDirect ? (
                <Grid item xs={12}
                  sx={(theme: Theme) => ({
                    [theme.breakpoints.down('sm')]: {
                      mt: "-14px"
                    }
                  })}>
                  <MFSubmitButton
                    fullWidth
                    label="Submit to BSE"
                    loadingEnable={loading}
                    disabled={!dirty}
                  />
                </Grid>

              ) : (
                <ProceedSaveLater
                  saveLater={() => {
                    setValues({
                      ...values,
                      nominees: values.nominees.map((nominee) => ({
                        ...nominee,
                        nomineeRelationship:
                          nominee.Relationship === 'OTHERS'
                            ? nominee.nomineeRelationship
                            : nominee.Relationship,
                      })),
                      saveType: 'save for later',
                    });
                  }}
                  saveAndProceed={() => {
                    setValues({
                      ...values,
                      nominees: values.nominees.map((nominee) => ({
                        ...nominee,
                        nomineeRelationship:
                          nominee?.Relationship === 'OTHERS'
                            ? nominee.nomineeRelationship
                            : nominee?.Relationship,
                      })),
                      saveType: 'save and proceed',
                    });
                  }}
                  loader={loading}
                  clickedButton={values.saveType}
                  saveButtonText="Continue"
                  showEndIcon={false}
                />
              )
            }

            <ConfirmationDialog
              showIcon
              // message={'Are you sure you want to delete nominee(s) ?'}
              message="Deleting nominee details"
              subMessage="Are you sure you want to delete the nominee details? "
              open={nomineeToDelete !== null || bulkNomineeDelete !== false}
              setOpen={() => {
                setBulkNomineeDelete(false);
                setNomineeToDelete(null);
              }}
              onSave={async () => {
                try {
                  const { id } = application || {};
                  const remainedApplicants = values.nominees.map((nominee, i) => {
                    if (nominee.sno === nomineeToDelete?.index || bulkNomineeDelete) {
                      return {
                        ...nominee,
                        isActive: false,
                      };
                    }
                    return nominee;
                  });
                  setValues({
                    ...values,
                    nominees: remainedApplicants,
                    doNotWishToNominate:
                      remainedApplicants.filter((item) => item.isActive).length === 0
                        ? true
                        : values.doNotWishToNominate,
                    nomineesSOA: remainedApplicants.filter((item) => item.isActive).length === 0 ? false : values.nomineesSOA
                  });
                  setBulkNomineeDelete(false);
                  setNomineeToDelete(null);
                } catch (e) {
                  console.error((e as Error).message);
                }
              }}
              onCancel={() => {
                setBulkNomineeDelete(false);
                setNomineeToDelete(null);
              }}
            />
          </Grid>
        )
      }}
    </Formik>
  );
}
